export default __webpack_public_path__ + "static/media/pa.3cf747ea.svg";